import { createContext, useContext } from 'react';
import type { Session, SupabaseClient } from '@supabase/supabase-js';

export interface AuthContextValue {
  supabase: SupabaseClient;
  session: Session | null;
  /** True until the first getSession()/onAuthStateChange round trip resolves. */
  isLoading: boolean;
  signOut: () => Promise<void>;
}

// Context + hook live in their own module, separate from the AuthProvider
// component (fix round 1, item 12) — a file that exports both a component
// and a hook trips `react-refresh/only-export-components`, since Fast
// Refresh can't tell which export is the component to preserve state for.
export const AuthContext = createContext<AuthContextValue | undefined>(undefined);

export function useAuth(): AuthContextValue {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within an AuthProvider');
  return ctx;
}
